import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const Level1 = () => {
  const [score, setScore] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [confettiElements, setConfettiElements] = useState([]);
  const [timeLeft, setTimeLeft] = useState(45);
  const timerRef = useRef(null);

  const inputRef = useRef(null);
 const correctSound = useRef(new Audio("https://www.orangefreesounds.com/wp-content/uploads/2014/11/ding.mp3"));
  const wrongSound = useRef(new Audio("https://www.orangefreesounds.com/wp-content/uploads/2014/08/Wrong-answer-sound-effect.mp3"));
 
  const questions = [
    { q: "What comes next? 4, 8, 12, ___", a: 16 },
    { q: "Double of 36?", a: 72 },
    { q: "Half of 48?", a: 24 },
    { q: "What is 100 – 37?", a: 63 },
    { q: "Round 368 to the nearest hundred", a: 400 },
    { q: "Estimate: 298 + 502", a: 800 },
    { q: "What is 1000 – 486?", a: 514 },
    { q: "Left-to-right: 45 + 32", a: 77 },
    { q: "Place value of 7 in 738?", a: 700 },
    { q: "Skip count by 25s: 25, 50, ___", a: 75 },
    { q: "What is 19 + 28 using friendly numbers?", a: 47 },
    { q: "Subtract using backtracking: 84 – 29", a: 55 },
    { q: "What is 63 – 9 using complements to 10?", a: 54 },
    { q: "What is the value of 3 in 439?", a: 30 },
    { q: "What is 76 – 9 using backtracking?", a: 67 }
  ];

  const normalizeAnswer = (input) => input.trim().toLowerCase().replace(/\s+/g, '');

  const moveToNextQuestion = () => {
    setCurrentQuestionIndex((prev) => prev + 1);
    setFeedback('');
    setTimeLeft(45);
    inputRef.current?.focus();
  };

  const checkAnswer = (e) => {
    e.preventDefault();
    clearInterval(timerRef.current);

    const userAnswerRaw = e.target.answer.value;
    inputRef.current.value = ''; 
    inputRef.current.focus();

    const correctAnswer = questions[currentQuestionIndex].a;
    let isCorrect = false;

    if (typeof correctAnswer === 'number') {
      isCorrect = Number(userAnswerRaw) === correctAnswer;
    } else {
      isCorrect = normalizeAnswer(userAnswerRaw) === normalizeAnswer(correctAnswer);
    }

    if (isCorrect) {
      correctSound.current.currentTime = 0;
      correctSound.current.play();
      setScore((prev) => prev + 1);
      setFeedback('🎉 Correct!');
      setFeedbackColor('#2e7d32');
      showConfetti();
    } else {
      wrongSound.current.currentTime = 0;
      wrongSound.current.play();
      setFeedback(`❌ Wrong! The correct answer is: ${correctAnswer}`);
      setFeedbackColor('#c62828');
    }

    setTimeout(() => {
      moveToNextQuestion();
    }, 1500);
  };

  const showConfetti = () => {
    const elements = [];
    for (let i = 0; i < 30; i++) {
      elements.push(
        <div
          key={i + Math.random()}
          style={{
            position: 'fixed',
            width: '10px',
            height: '10px',
            backgroundColor: `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`,
            opacity: 0.8,
            pointerEvents: 'none',
            animation: `fall ${2 + Math.random() * 2}s linear forwards`,
            left: Math.random() * window.innerWidth + 'px'
          }}
        ></div>
      );
    }
    setConfettiElements(elements);
    setTimeout(() => setConfettiElements([]), 3000);
  };

  useEffect(() => {
    if (!questions[currentQuestionIndex]) return;
    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          wrongSound.current.currentTime = 0;
          wrongSound.current.play();
          setFeedback(`⏰ Time's up! The correct answer was: ${questions[currentQuestionIndex].a}`);
          setFeedbackColor('#c62828');
          setTimeout(() => {
            moveToNextQuestion();
          }, 1500);
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [currentQuestionIndex]);

  const question = questions[currentQuestionIndex];

          useEffect(() => {
          if (currentQuestionIndex === questions.length) {
            const responsedata = ConstructorEventUpdateSQLStatus();
            console.log("Event completed", responsedata);
          }
        }, [currentQuestionIndex]);

  return (
    <div style={{
      fontFamily: 'Poppins, sans-serif',
      backgroundImage: 'url("https://as1.ftcdn.net/jpg/03/29/41/98/1000_F_329419895_2LKInappp1st56Vvb35lo9bxb2Zppawh.jpg")',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      minHeight: '100vh',
      overflowX: 'hidden',
      padding: '1rem'
    }}>
      {confettiElements}
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <div style={{
          background: '#fff',
          border: '3px solid #4a148c',
          borderRadius: '30px',
          padding: '5vw',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center'
        }}>
          <h2 style={{
            fontSize: '1.8rem',
            color: '#4a148c',
            fontFamily: 'Comic Neue, cursive',
            textShadow: '1px 1px 3px #b39ddb'
          }}>
            Score → <span>{score}</span>
          </h2>
          <h3 style={{ fontSize: '1.2rem', margin: '20px 0 30px', minHeight: '3em' }}>
            {question ? question.q : `🎉 Quiz Complete! Your final score is ${score} / ${questions.length}`}
          </h3>

          {question && (
            <form onSubmit={checkAnswer} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <input
                ref={inputRef}
                name="answer"
                type="text"
                required
                autoComplete="off"
                inputMode="numeric"
                style={{
                  fontSize: '1.2rem',
                  padding: '1rem',
                  border: '2px solid #4a148c',
                  borderRadius: '15px',
                  textAlign: 'center'
                }}
              />
              <button
                type="submit"
                style={{
                  padding: '1rem',
                  backgroundColor: '#4a148c',
                  color: '#fff',
                  fontSize: '1.4rem',
                  fontWeight: 700,
                  border: 'none',
                  borderRadius: '15px',
                  cursor: 'pointer'
                }}
              >
                Submit
              </button>
              <div style={{ fontSize: '1.5rem', color: '#4a148c', fontWeight: 'bold' }}>
                ⏳ Time Left: {timeLeft}s
              </div>
            </form>
          )}

          <div style={{
            fontSize: '1rem',
            marginTop: '15px',
            height: '30px',
            fontWeight: 700,
            fontFamily: 'Comic Neue, cursive',
            color: feedbackColor
          }}>
            {feedback}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(600px) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default Level1;


 